import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PersonIcon from "@material-ui/icons/Person";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Tooltip from "@material-ui/core/Tooltip";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import { _MainContent, _PageTitle, _PageWrapper } from "../../inar2/layout";
import { _ButtonAPI, _SecureCard, _UserDetails, _UserGroups, _UserProfile } from "../../inar2/components";

interface IRouteParam {
    ID_Utente: string;
}

const useStyles = makeStyles(({ spacing }: Theme) => ({
    btnWrapper: { marginTop: spacing(1) }
}));

export const _User: React.FC<Glob.IRouteGlobaleProps> = props => {
    const classes = useStyles();
    const { ID_Utente } = useParams<IRouteParam>();

    const [UserData, setUserData] = useReducerOnChange<Dati.CDatiUtente>(new Dati.CDatiUtente());
    const [Groups, setGroups] = useReducerOnChange<Dati.Dictionary<boolean>>({});

    useEffect(() => {
        props.SetMenu({ ...Glob.GetMenu(), Main: "Utente", ID_MenuMain: 32 });
    }, []);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("UtentiController", Glob.Lettura) && !(Glob.AzioneAbilitata("ProprioUtente", Glob.Lettura) && UserData.ID_Utente == Glob.GetSessione().ID_Utente)) {
            location.replace("/ErroreAccesso");
            return;
        }
        GetUser();
        GetGroups();
    }, ["", ID_Utente]);

    const GetUser = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/seleziona?id_utente=${ID_Utente}`,
            OnRis: OnGetUser
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetUser = (sender: ChiamaWeb, dati: Dati.CRisAPIDatoTipiInfoUtente) => {
        dati.Dato.Password = "";
        setUserData({ Type: "Set", Value: dati.Dato.ID_Utente ? dati.Dato : new Dati.CDatiUtente() });
    };

    const GetGroups = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/GruppiAttiviUtente?id_utente=${ID_Utente}`,
            OnRis: OnGetGroups
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetGroups = (sender: ChiamaWeb, dati: Dati.CRisAPIDizionario<boolean>) => {
        setGroups({ Type: "Set", Value: dati.Dati });
    };

    const OnGroupChange = (key: string, val: boolean) => {
        setGroups({ Type: "OnChangeFromValue", Name: key, Value: val });
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            props.SetDialog({ Open: true, Title: "ERRORE", Content: `${data.ErrTesto} ${data.ErrTesti[0] ?? ""}`, Type: "error" });
        } else {
            if (UserData.ID_Utente == 0) {
                props.history.push(`/Utente/${data.ID_Chiave}`);
            }
            props.SetDialog({ Open: true, Title: "UTENTE", Content: Trad.TradParam("UtenteSalvatoCorrettamenteConIdUtente{1-S}", [data.ID_Chiave]), Type: "success" });
        }
    };

    const OnError = (error: Error) => {
        props.SetDialog({ Open: true, Title: "ERRORE", Content: error.message, Type: "error" });
    };

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PersonIcon} Title="Anagrafica">
                    {Glob.AzioneAbilitata("UtentiController", Glob.Scrittura) && (
                        <NavLink to="/Utente/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <PersonAddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid container item xs={12} md={3} spacing={2}>
                            <Grid item xs={12}>
                                <_UserProfile Data={UserData} SetDialog={props.SetDialog} OnImageChange={fileName => setUserData({ Type: "OnChangeFromValue", Name: "Immagine", Value: fileName })} />
                            </Grid>
                            <Grid item xs={12}>
                                <_SecureCard UserId={UserData.ID_Utente} SetDialog={props.SetDialog} />
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} md={9} spacing={2}>
                            <Grid item xs={12}>
                                <_UserDetails
                                    Data={UserData}
                                    SetDialog={props.SetDialog}
                                    OnChange={(e, val) => setUserData({ Type: "OnChangeFromHybrid", NameEvent: val != null && val != undefined ? e : Object.assign({}, e), Value: val })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <_UserGroups Groups={Groups} OnGroupChange={OnGroupChange} />
                            </Grid>
                            <Grid container item xs={12} justify="flex-end" className={classes.btnWrapper}>
                                <_ButtonAPI
                                    Default
                                    Testo={Trad.Trad("Salva")}
                                    URL={`/api/Utenti/inar2/InAR2_Post/${UserData.ID_Utente}`}
                                    ParamCorpo={{ ...UserData, Gruppi: Groups }}
                                    OnClick={OnClickSave}
                                    OnErrore={OnError}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/User.tsx